module.exports = __webpack_public_path__ + "img/teleconsultation_avec_rv.a826a903.png";